import { toast } from "sonner";

interface ToastOpts {
  /** Optional action button rendered inside the toast (e.g. "Try again"). */
  action?: { label: string; onClick: () => void };
}

// Custom toast styling to ensure proper colors
export const customToast = {
  success: (message: string, opts?: ToastOpts) =>
    toast.success(message, {
      style: {
        background: "hsl(142 76% 36%)",
        color: "white",
        border: "1px solid hsl(142 76% 46%)",
      },
      ...(opts?.action ? { action: opts.action } : {}),
    }),
  error: (message: string, opts?: ToastOpts) =>
    toast.error(message, {
      style: {
        background: "hsl(0 84% 60%)",
        color: "white",
        border: "1px solid hsl(0 84% 70%)",
      },
      ...(opts?.action ? { action: opts.action } : {}),
    }),
  /**
   * In-progress state — neither a success nor a failure.
   *
   * Added for the one case that genuinely is neither: a payment that went
   * through while the entitlement behind it has not landed yet. Green would
   * claim the upgrade finished (the false confirmation in PANDA-2292) and red
   * would tell someone their payment failed when it did not. Amber says "we
   * have your money, we are still working", which is the true statement.
   */
  info: (message: string, opts?: ToastOpts) =>
    toast(message, {
      style: {
        background: "hsl(38 92% 50%)",
        color: "hsl(20 14% 12%)",
        border: "1px solid hsl(38 92% 60%)",
      },
      ...(opts?.action ? { action: opts.action } : {}),
    }),
};
